// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentConfig } from "./environment.model";
const cdn = 'https://assets.tdwilliamson.com/';
export const shared: Partial<EnvironmentConfig> = {
  production: false,
  environmentName: 'local',
  debugMode: true,
  logToConsole: true,
  appVersion: require('../../package.json').version,
  appInsights: {
    instrumentationKey: '4aba6a45-0ef4-4076-998d-2da520db0d81',
    enableAutoRouteTracking: true, // option to log all route changes
    autoTrackPageVisitTime: true,
    enableCorsCorrelation: true
  },
  registration: {
    scopeUri: ['api://2c52afb9-1362-4bfc-8284-0bced61075bd/ProductSelector.Read'],
    tenantId: 'da7cba33-a475-42a2-a6d2-d3eabac375db',
    uiClientId: 'fa70bfd9-750d-4cea-8c90-748c020eeb6b',
    redirectUrl: 'http://localhost:4200',
    protectedResources: [
      ['https://localhost:44353/', ['api://2c52afb9-1362-4bfc-8284-0bced61075bd/ProductSelector.Read']],
      ['https://localhost:7248/', ['api://768cf90d-a13f-419a-afaf-70f67bcaa9e4/read']],
      ['https://localhost:7150/', ['api://05d1e5b0-51d7-49d3-b2e0-8bdbc4bdd9c0/read']],
      ['https://graph.microsoft.com/v1.0/me', ['user.read']]
    ]
  },
  containers: {
    drawings: 'product-selector-dwgs-dev'
  },
  endpoints: {
    baseApi: { url: 'https://localhost:44353/', version: 'v1' },
    local: { url: 'assets/', version: '' },
    sealingElementsApi: { url: 'https://localhost:7248/', version: 'v2' },
    oRingsApi: { url: 'https://localhost:7150/', version: 'v1' }
  },
  modalOptions: {
    animation: true,
    keyboard: false,
    backdrop: 'static'
  },
  closureImgReference: {
    le14: {
      left: {
        flange: `${cdn}img/D2000Closures/Closure-6in-Flanged-LH.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-6in-LH.png`
      },
      right: {
        flange: `${cdn}img/D2000Closures/Closure-6in-Flanged-RH.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-6in-RH.png`
      }
    },
    gt15lt32: {
      left: {
        flange: `${cdn}img/D2000Closures/Closure-16in-LH-Flanged.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-16in-LH.png`
      },
      right: {
        flange: `${cdn}img/D2000Closures/Closure-16in-RH-Flanged.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-16in-RH.png`
      }
    },
    actuated24to30: {
      left: {
        flange: `${cdn}img/D2000Closures/Closure-24in-LH-Actuated-Flanged.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-24in-LH-Actuated.png`
      },
      right: {
        flange: `${cdn}img/D2000Closures/Closure-24in-RH-Actuated-Flanged.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-24in-RH-Actuated.png`
      }
    },
    gt32: {
      left: {
        flange: `${cdn}img/D2000Closures/Closure-36in-LH-Actuated-Flanged.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-36in-LH-Actuated.png`
      },
      right: {
        flange: `${cdn}img/D2000Closures/Closure-36in-RH-Actuated-Flanged.png`,
        noFlange: `${cdn}img/D2000Closures/Closure-36in-RH-Actuated.png`
      }
    }
  }
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
